<div class="container-fluid imgfond py-4">
<!--   <div class="row">
    <div class="col-12">
      <h1 class="text-center mx-2 fw-bold nunito">Regístrate</h1>
    </div>
  </div> -->
    <div class="row justify-content-center ">
      <form class="col-11 rounded col-lg-9 px-0 bg-white pc" [formGroup]="registerForm" (ngSubmit)="onSubmit(registerForm.value)" >
      <div class="shadow-sm p-2 bg-ligth mb-4 rounded " [hidden]="boolRegister1">
        <h2 class="fw-bold mb-0 ">
          <i class="bi bi-info-circle" *ngIf="f.name.invalid || f.apellido.invalid || f.telefono.invalid || f.email.invalid || f.password.invalid" matTooltip="Faltan campos por llenar"></i>
          <i class="bi bi-check-circle" *ngIf="f.name.valid && f.apellido.valid && f.telefono.valid && f.email.valid && f.password.valid" matTooltip="Campos completos"></i>
          Información General
        </h2>
        <div class="row my-2">
          <div class="col-12 col-lg-6">
            <div class="form-group " >
                <label for="name">
                <i class="bi bi-info-circle" *ngIf="f.name.invalid" matTooltip="campo obligatorio"></i>
                <i class="bi bi-check-circle" *ngIf="f.name.valid" matTooltip="campo obligatorio"></i>
                  Nombre 
                </label>
                <input id="name" type="text" class="form-control" formControlName="name" placeholder="Ingresa tu nombre" />
              <div *ngIf="f.name.touched && f.name.invalid" class="text-danger">El nombre es obligatorio.</div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mt-3 mt-lg-0">
            <div class="form-group">
              <label for="apellido">
                <i class="bi bi-info-circle" *ngIf="f.apellido.invalid" matTooltip="campo obligatorio"></i>
                <i class="bi bi-check-circle" *ngIf="f.apellido.valid" matTooltip="campo obligatorio"></i>
                Apellidos
              </label>
              <input id="apellido" type="text" class="form-control" formControlName="apellido" placeholder="Ingresa tus Apellidos" />
              <div *ngIf="f.apellido?.touched && f.apellido?.invalid" class="text-danger">El apellido es obligatorio.</div>
            </div>
          </div>
        </div>
        
        <div class="row my-2">
          <div class="col-12 col-lg-6 order-2 order-lg-1">
            <div class="form-group">
              <label for="email">
                <i class="bi bi-info-circle" *ngIf="f.email.invalid" matTooltip="campo obligatorio"></i>
                <i class="bi bi-check-circle" *ngIf="f.email.valid" matTooltip="campo obligatorio"></i>
                Correo Electrónico 
              </label>
              <input id="email" type="email" class="form-control" formControlName="email" placeholder="Ingresa tu correo" />
              <div *ngIf="f.email.touched && f.email.invalid" class="text-danger">
                <div *ngIf="f.email.errors?.required">El correo electrónico es obligatorio.</div>
                <div *ngIf="f.email.errors?.email">Ingresa un correo electrónico válido.</div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mt-3 mt-lg-0 order-1 order-lg-2 ">
            <div class="form-group">
              <label for="telefono">
                <i class="bi bi-info-circle" *ngIf="f.telefono.invalid" matTooltip="campo obligatorio"></i>
                <i class="bi bi-check-circle" *ngIf="f.telefono.valid" matTooltip="campo obligatorio"></i>
                Teléfono 
              </label>
              <input id="telefono" type="number" class="form-control" formControlName="telefono" placeholder="Ingresa tu número de teléfono"  (input)="limitarTelefono($event)"  [maxlength]="10" />
              <div *ngIf="f.telefono?.touched && f.telefono?.invalid" class="text-danger">Ingrese un número de teléfono válido</div>
            </div>
          </div>
        </div>
        <div class="row my-2">
          <div class="col-12 col-lg-6">
              <div class="form-group">
             <label for="password">
            <i class="bi bi-info-circle" *ngIf="f.password.invalid" matTooltip="campo obligatorio"></i>
            <i class="bi bi-check-circle" *ngIf="f.password.valid" matTooltip="campo obligatorio"></i>
            Contraseña
            </label>
            <!-- Icono para mostrar/ocultar la contraseña a la derecha -->
            <div class="input-group">
              <input id="password" [type]="passwordVisible ? 'text' : 'password'" class="form-control" formControlName="password" placeholder="Ingresa tu contraseña"  />
              <span class="input-group-text pointer" (click)="togglePasswordVisibility()">
                <i [class]="passwordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
              </span>
            </div>
          <div *ngIf="f.password.touched && f.password.invalid" class="text-danger">
            <div *ngIf="f.password.errors?.required">La contraseña es obligatoria.</div>
            <div *ngIf="f.password.errors?.minlength">La contraseña debe tener al menos 6 caracteres.</div>
          </div>
        </div>
        </div>
          <div class="col-12 col-lg-6 mt-3 mt-lg-0 order-1 order-lg-2 d-flex align-items-center">
            <div (click)="fncontinuar()" class="d-flex mx-auto align-items-center text-decoration-underline text-primary">
              <span class="nunito fw-bold me-1">CONTINUAR</span>
              <span class="mx-auto btn btn-primary rounded-circle p-0 d-flex align-items-center justify-content-center shadow-sm" style="height: 40px;width: 40px;">
              <i class="bi bi-arrow-right-circle-fill fs-5"></i>
            </span>
            </div>
          </div>
        </div>
        
        
      
      </div>
  
      <div class="shadow-sm p-2 bg-white mb-4 rounded bgcard" [hidden]="!boolRegister1">
        <h2 class="fw-bold mb-0 d-flex">
          <span (click)="fncontinuar();" class="me-2 d-flex">
<span  class="btn btn-secondary rounded-circle p-0 d-flex align-items-center justify-content-center shadow-sm" style="height: 25px;width: 25px;">
             <i class="bi bi-arrow-left-circle-fill fs-6 "></i>  
            </span>
            <span class=" nunito fw-bold fs13 text-secondary">Regresar</span>
          </span>
            <span class="mx-auto">
<i class="bi bi-info-circle" *ngIf="f.nombreComercial.invalid || f.razonSocial.invalid || f.rfc.invalid || f.regimenFiscal.invalid || f.usoCfdi.invalid || f.codigoPostal.invalid || f.estado.invalid || f.ciudad.invalid || f.colonia.invalid || f.calle.invalid || f.numeroExterior.invalid" matTooltip="Faltan Campos por llenar"></i>
            <i class="bi bi-check-circle" *ngIf="f.nombreComercial.valid && f.razonSocial.valid && f.rfc.valid && f.regimenFiscal.valid && f.usoCfdi.valid && f.codigoPostal.valid && f.estado.valid && f.ciudad.valid && f.colonia.valid && f.calle.valid && f.numeroExterior.valid" matTooltip="Campos completos"></i> 
            Información Fiscal 
            </span> 
            
        </h2>
        
        <div class="row my-1">
          <div class="col-12 col-lg-6">
            <div class="form-group">
            <label for="nombreComercial">
              <i class="bi bi-info-circle" *ngIf="f.nombreComercial.invalid" matTooltip="campo obligatorio"></i>
              <i class="bi bi-check-circle" *ngIf="f.nombreComercial.valid" matTooltip="campo obligatorio"></i>
              Nombre Comercial
            </label>
            <input id="nombreComercial" type="text" class="form-control" formControlName="nombreComercial" placeholder="Ingresa Nombre Comercial"  />
            <div *ngIf="f.nombreComercial.touched && f.nombreComercial.invalid" class="text-danger">El Nombre Comercial es obligatorio.</div>
          </div>
          </div>
          <div class="col-12 col-lg-6  mt-lg-0">
            <div class="form-group">
          <label for="razonSocial">
            <i class="bi bi-info-circle" *ngIf="f.razonSocial.invalid" matTooltip="campo obligatorio"></i>
            <i class="bi bi-check-circle" *ngIf="f.razonSocial.valid" matTooltip="campo obligatorio"></i>
            Razón Social 
          </label>
          <input id="razonSocial" type="text" class="form-control" formControlName="razonSocial" placeholder="Ingresa tu razón social" />
          <div *ngIf="f.razonSocial.touched && f.razonSocial.invalid" class="text-danger">La razón social es obligatoria.</div>
         
        </div>
          </div>
        </div>


        <div class="row my-1">
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <label for="rfc">
                <i class="bi bi-info-circle" *ngIf="f.rfc.invalid" matTooltip="campo obligatorio"></i>
                <i class="bi bi-check-circle" *ngIf="f.rfc.valid" matTooltip="campo obligatorio"></i>
                RFC
              </label>
              <input id="rfc" type="text" class="form-control" formControlName="rfc"  placeholder="Ingresa RFC"/>
              <div *ngIf="f.rfc.touched && f.rfc.invalid" class="text-danger">El RFC es obligatorio.</div>
            </div>
          </div>
          <div class="col-12 col-lg-6  mt-lg-0">
            <div class="form-group">
              <label for="regimenFiscal">
                <i class="bi bi-info-circle" *ngIf="f.regimenFiscal.invalid" matTooltip="campo obligatorio"></i>
                <i class="bi bi-check-circle" *ngIf="f.regimenFiscal.valid" matTooltip="campo obligatorio"></i>
                Régimen Fiscal  
              </label>
              <select id="regimenFiscal" class="form-select" aria-label="Default select example" formControlName="regimenFiscal">
                <option value ="">--Seleccione--</option>
                <option *ngFor = "let col of arrayRegimenFiscal" [value]="col.strFiscalRegimen">{{col.strDescripcion}}</option> 
              </select>
              <div *ngIf="f.regimenFiscal.touched && f.regimenFiscal.invalid" class="text-danger">El Régimen Fiscal es obligatorio.</div>
            </div>
          </div>
        </div>



        <div class="row my-1">
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <label for="usoCfdi">
              <i class="bi bi-info-circle" *ngIf="f.usoCfdi.invalid" matTooltip="campo obligatorio"></i>
              <i class="bi bi-check-circle" *ngIf="f.usoCfdi.valid" matTooltip="campo obligatorio"></i>
              Uso de CFDI  
          </label>
          
          <select id="usoCfdi" class="form-select" aria-label="Default select example" formControlName="usoCfdi">
            <option value="">--Seleccione--</option>
            <option *ngFor = "let col of arrayCfdi" [value]="col.strClaveUsoCFDI">{{col.strDescripcion}}</option> 
          </select>
          <div *ngIf="f.usoCfdi.touched && f.usoCfdi.invalid" class="text-danger">El Uso de CFDI es obligatorio.</div>
        </div>
          </div>
          <div class="col-12 col-lg-6 mt-lg-0">
            <label for="codigoPostal">
              <i class="bi bi-info-circle" *ngIf="f.codigoPostal.invalid" matTooltip="campo obligatorio"></i>
              <i class="bi bi-check-circle" *ngIf="f.codigoPostal.valid" matTooltip="campo obligatorio"></i>
              Código Postal   
            </label>
            <input id="codigoPostal" type="text" class="form-control" formControlName="codigoPostal" placeholder="Ingresa Código Postal" (input)="onInputChange($event)"  (keydown)="onKeyDown($event)" [maxlength]="15"/>
            <div *ngIf="f.codigoPostal.touched && f.codigoPostal.invalid" class="text-danger">El Código Postal es obligatorio.</div>
         
          </div>
        </div>


        <div class="row my-2">
          <div class="col-12 col-lg-6">
                 <label for="estado">
              <i class="bi bi-info-circle" *ngIf="f.estado.invalid" matTooltip="campo obligatorio"></i>
              <i class="bi bi-check-circle" *ngIf="f.estado.valid" matTooltip="campo obligatorio"></i>
              Estado  
              
            </label>
            <input id="estado" readonly type="text" class="form-control" formControlName="estado" placeholder="Ingresa Estado"/>
            <div *ngIf="f.estado.touched && f.estado.invalid" class="text-danger">El estado es obligatorio.</div>
         
          </div>
          <div class="col-12 col-lg-6 mt-3 mt-lg-0">
  <label for="ciudad">
              <i class="bi bi-info-circle" *ngIf="f.ciudad.invalid" matTooltip="campo obligatorio"></i>
              <i class="bi bi-check-circle" *ngIf="f.ciudad.valid" matTooltip="campo obligatorio"></i>
              Ciudad 
              
            </label>
            <input id="ciudad" type="text" class="form-control" readonly formControlName="ciudad" placeholder="Ingresa Ciudad" />
            <div *ngIf="f.ciudad.touched && f.ciudad.invalid" class="text-danger">La Ciudad es obligatoria.</div>
         
          </div>
        </div>
        

        <div class="row my-2">
          <div class="col-12 col-lg-6">
             <label for="colonia">
              <i class="bi bi-info-circle" *ngIf="f.colonia.invalid" matTooltip="campo obligatorio"></i>
              <i class="bi bi-check-circle" *ngIf="f.colonia.valid" matTooltip="campo obligatorio"></i>
              Colonia  
            </label> 

            <select id="colonia" class="form-select" aria-label="Default select example" formControlName="colonia">
              <option value ="">--Seleccione Colonia--</option>
              <option *ngFor = "let col of arrayColonias" [value]="col.strColonia">{{col.strColonia}}</option> 
            </select>

            <div *ngIf="f.colonia.touched && f.colonia.invalid" class="text-danger">La Colonia es obligatoria.</div>
         
          </div>
          <div class="col-12 col-lg-6 mt-3 mt-lg-0">
<div class="form-group">
          <label for="calle">
            <i class="bi bi-info-circle" *ngIf="f.calle.invalid" matTooltip="campo obligatorio"></i>
            <i class="bi bi-check-circle" *ngIf="f.calle.valid" matTooltip="campo obligatorio"></i>
            Calle  
          </label>
          <input id="calle" type="text" class="form-control" formControlName="calle" placeholder="Ingresa Calle"/>
          <div *ngIf="f.calle.touched && f.calle.invalid" class="text-danger">La Calle es obligatoria.</div>
         
        </div>
          </div>
        </div>

        <div class="row my-2">
          <div class="col-12 col-lg-6">
             <label for="numeroExterior">
              <i class="bi bi-info-circle" *ngIf="f.numeroExterior.invalid" matTooltip="campo obligatorio"></i>
              <i class="bi bi-check-circle" *ngIf="f.numeroExterior.valid" matTooltip="campo obligatorio"></i>
              Número Exterior  
            </label>
            <input id="numeroExterior" type="text" class="form-control" formControlName="numeroExterior" placeholder="Ingresa Número"/>
            <div *ngIf="f.numeroExterior?.touched && f.numeroExterior?.invalid" class="text-danger">Número Exterior es Obligatorio.</div>
         
          </div>
          <div class="col-12 col-lg-6 mt-3 mt-lg-0">
  <label for="numeroInterior">Número Interior <span class="fs9">(Opcional)</span></label>
            <input id="numeroInterior" type="text" class="form-control" formControlName="numeroInterior"  placeholder="Ingresa Número"/>
         
          </div>
        </div>

        <!-- <div class="row my-2">
          <div class="col-12 col-lg-6">
            
          </div>
          <div class="col-12 col-lg-6 mt-3 mt-lg-0">

          </div>
        </div> -->



          
      </div>
  
      <button [hidden]="!boolRegister1" type="submit" class="btn btn-primary mt-2"  [disabled]="registerForm.invalid">Registrarse </button>
      <div class="row mt-2" [hidden]="!boolRegister1">
        <div class="col-12 text-center">
          <span class="text-muted">
            Al registrarte aceptas los 
            <a class="text-primary text-decoration-underline" data-bs-toggle="modal" data-bs-target="#exampleModal"  (click)="fnModal('terminosCondiciones','Términos y Condiciones de Uso')">Términos y Condiciones</a> y el 
            <a class="text-primary text-decoration-underline" data-bs-toggle="modal" data-bs-target="#exampleModal" (click)="fnModal('privacidad','TERMINOS DE USO')">Terminos de uso</a>.
          </span>
        </div>
      </div>
      
      <div class="login-link">
        <p>¿Ya tienes una cuenta? <a routerLink="/login-partner">Inicia sesión</a></p>
      </div>
      </form>
    </div>
  </div>














<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <div class="row w-100">
          <div class="col-11">
            <h2 class="modal-title" id="exampleModalLabel" class="mx-auto mb-0">{{modalAvisos.titulo}}</h2>
        </div>
          <div class="col-1">
             <button type="button" class="btn-close bg-dark" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
        </div>
          </div>
      <div class="modal-body">
        <div class="container " *ngIf="modalAvisos.aviso=='privacidad'">
    <div class="container my-5">
  <h1 class="mb-4 text-center">Condiciones de Uso</h1>

  <div class="mb-4">
    <h4>Uso de tus datos</h4>
    <p>Al proporcionarnos tus datos de contacto (nombre, correo electrónico, número telefónico u otros), aceptas que <strong>Ecodeli</strong> los utilice para enviarte información relevante sobre nuestros productos, servicios, promociones y actualizaciones, incluyendo mensajes publicitarios a través de correo electrónico, mensajes de texto u otros medios.</p>
  </div>

  <div class="mb-4">
    <h4>Privacidad y protección de datos</h4>
    <p>Tus datos serán tratados de forma confidencial conforme a nuestra <strong>Política de Privacidad</strong>. No compartiremos tu información con terceros sin tu consentimiento, salvo en los casos previstos por la ley.</p>
  </div>

  <div class="mb-4">
    <h4>Cancelación de envíos</h4>
    <p>Podrás darte de baja de nuestras comunicaciones publicitarias en cualquier momento siguiendo las instrucciones incluidas en cada mensaje.</p>
  </div>

  <div class="mb-4">
    <h4>Modificaciones</h4>
    <p><strong>Ecodeli</strong> se reserva el derecho de modificar estas condiciones en cualquier momento. Cualquier cambio será notificado a través del sitio web.</p>
  </div>

</div>


</div>

<div class="container-fluid" *ngIf="modalAvisos.aviso=='terminosCondiciones'">
  <div class="container my-5">
    <h1 class="mb-4 text-center">Términos y Condiciones de Uso</h1>

    <p><strong>Bienvenido(a)</strong> a <strong>www.ecodeli.com</strong> (en adelante "el Sitio").</p>
    <p>El Sitio opera bajo las leyes de la <strong>República Mexicana</strong>, y al utilizarlo, aceptas los siguientes términos y condiciones:</p>

    <div class="mt-4">
        <h4>1. Uso del Sitio</h4>
        <p>El Sitio tiene como objetivo la venta de productos de limpieza y artículos relacionados.</p>
        <p>El acceso y uso del Sitio implica la aceptación plena de estos Términos y Condiciones.</p>
        <p>Nos reservamos el derecho de modificar los Términos en cualquier momento. Las modificaciones serán publicadas y surtirán efectos de inmediato.</p>
    </div>

    <div class="mt-4">
        <h4>2. Registro de Usuarios</h4>
        <p>Para comprar productos, es posible que debas registrarte proporcionando información veraz, completa y actualizada.</p>
        <p>Al registrarte, autorizas a <strong>www.ecodeli.com</strong> a utilizar tus datos conforme a nuestro Aviso de Privacidad.</p>
    </div>

    <div class="mt-4">
        <h4>3. Uso de Información Personal</h4>
        <p>La información proporcionada se utilizará para:</p>
        <ul>
            <li>Procesar compras.</li>
            <li>Enviar notificaciones de pedidos.</li>
            <li>Enviar promociones, descuentos y noticias relacionadas.</li>
            <li>Dar cumplimiento a obligaciones legales.</li>
        </ul>
        <p>En todo momento, puedes solicitar el acceso, rectificación, cancelación u oposición (derechos ARCO) de tus datos, conforme a la ley aplicable.</p>
    </div>

    <div class="mt-4">
        <h4>4. Propiedad Intelectual</h4>
        <p>Todo el contenido del Sitio (textos, imágenes, logotipos) es propiedad de <strong>www.ecodeli.com</strong> o de sus proveedores, y está protegido por las leyes mexicanas de propiedad intelectual.</p>
    </div>

    <div class="mt-4">
        <h4>5. Responsabilidades</h4>
        <p>Nos esforzamos en asegurar que toda la información sea correcta, pero no garantizamos que el Sitio esté libre de errores.</p>
        <p>No nos hacemos responsables por daños derivados del uso o imposibilidad de uso del Sitio.</p>
    </div>

    <div class="mt-4">
        <h4>6. Legislación Aplicable</h4>
        <p>Este acuerdo se rige por las leyes de los Estados Unidos Mexicanos.</p>
        <p>Cualquier controversia será sometida a los tribunales competentes de la Ciudad de México.</p>
    </div>
</div>
</div>
      </div>
      <div class="modal-footer d-flex ">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>

      </div>
    </div>
  </div>
</div>



